import Vue from 'vue'
import VueRouter from 'vue-router'

// import { i18n } from '@/i18n'
import { Trans } from '@/plugins/translation'

function load(pathToPageComponent) {
  return () => import(`@/views/${pathToPageComponent}`)
}

Vue.use(VueRouter)
let routePath = []
if (process.env.VUE_APP_CLOSED && !document.cookie.includes('access')) {
  routePath = [
    {
      path: '*',
      name: 'Plug',
      component: load('Plug'),
      meta: {
        needAuth: false,
        layout: 'empty',
      },
    },
  ]
} else {
  routePath = [
    {
      path: '',
      name: 'Home',
      meta: {
        layout: 'default',
      },
      component: load('Home'),
    },
    {
      path: 'success-academy',
      name: 'SuccessAcademy',
      meta: {
        auth: true,
        layout: 'default',
      },
      component: load('success-academy/SuccessAcademy'),
    },
    {
      path: 'success-academy/:slug',
      name: 'SuccessAcademySections',
      meta: {
        auth: true,
        layout: 'default',
        parent_page: 'SuccessAcademy',
      },
      component: load('success-academy/sections/SuccessAcademySections'),
    },
    {
      path: 'hn-grow/',
      name: 'HNGrow',
      meta: {
        auth: true,
        layout: 'default',
      },
      component: load('HNGrow'),
    },
    {
      path: 'intensives/',
      name: 'Intensives',
      meta: {
        auth: true,
        layout: 'default',
      },
      component: load('intensives/IntensivesMain'),
    },
    {
      path: 'intensives/:slug',
      name: 'Intensive',
      meta: {
        auth: true,
        layout: 'intensive',
      },
      component: load('intensives/IntensiveDetail'),
    },
    {
      path: 'intensives/:slug/screencast',
      name: 'Screencast',
      meta: {
        auth: true,
        layout: 'intensive',
      },
      component: load('screencasts/Screencasts'),
    },
    {
      path: 'trainings/',
      name: 'Trainings',
      meta: {
        auth: true,
        layout: 'default',
        parent_page: 'Home',
      },
      component: load('trainings/TrainingsMain'),
    },
    {
      path: 'trainings/qualification/',
      name: 'Qualification',
      meta: {
        auth: true,
        layout: 'default',
        parent_page: 'Trainings',
      },
      component: load('trainings/Qualification'),
    },
    {
      path: 'trainings/new-section/',
      name: 'Qualification2',
      meta: {
        auth: true,
        layout: 'default',
        parent_page: 'Trainings',
      },
      component: load('trainings/Qualification2'),
    },
    {
      path: 'webinars/',
      name: 'Webinars',
      meta: {
        auth: true,
        layout: 'default',
        parent_page: 'Home',
      },
      component: load('webinars/WebinarsMain'),
    },
    {
      path: 'distribution-system/',
      name: 'System',
      meta: {
        auth: true,
        layout: 'default',
        parent_page: 'Home',
      },
      component: load('System'),
    },
    {
      path: 'onboarding/',
      name: 'Onboarding',
      meta: {
        auth: true,
        layout: 'default',
        parent_page: 'Home',
      },
      component: load('Onboarding'),
    },
    {
      path: 'useful-resources/',
      name: 'UsefulResources',
      meta: {
        auth: true,
        layout: 'default',
        parent_page: 'Home',
      },
      component: load('UsefulResources'),
    },
    {
      path: 'network-security-webinars/',
      name: 'NetworkSecurity',
      meta: {
        auth: true,
        layout: 'default',
        parent_page: 'Home',
      },
      component: load('networkSecurity/NetworkSecurity'),
    },
    {
      path: 'cabinet/',
      name: 'Cabinet',
      meta: {
        auth: true,
        layout: 'cabinet',
        parent_page: 'Home',
      },
      component: load('cabinet_v2/Main'),
    },
    {
      path: 'cabinet/user',
      name: 'CabinetUserData',
      meta: {
        auth: true,
        layout: 'cabinet',
        parent_page: 'Home',
      },
      component: load('cabinet_v2/UserData'),
    },
    {
      path: 'cabinet/prizes',
      name: 'CabinetPrizes',
      meta: {
        auth: true,
        layout: 'cabinet',
        parent_page: 'Home',
      },
      component: load('cabinet_v2/Prizes'),
    },
    {
      path: 'cabinet/achievements',
      name: 'CabinetAchievements',
      meta: {
        auth: true,
        layout: 'cabinet',
        parent_page: 'Home',
      },
      component: load('cabinet_v2/Achievements'),
    },
    {
      path: 'cabinet/favorites/',
      name: 'Favorites',
      meta: {
        auth: true,
        layout: 'cabinet',
        parent_page: 'Cabinet',
      },
      component: load('cabinet/Favorites'),
    },
    {
      path: 'cabinet/statistics/',
      name: 'Statistics',
      meta: {
        auth: true,
        layout: 'cabinet',
        parent_page: 'Cabinet',
      },
      component: load('cabinet/Statistics'),
    },
    {
      path: 'cabinet/my-team/',
      name: 'Referal',
      meta: {
        auth: true,
        layout: 'cabinet',
        parent_page: 'Cabinet',
      },
      component: load('cabinet_v2/Referal'),
    },
    {
      path: 'success-wall',
      name: 'SuccessLadder',
      component: load('SuccessWall/SuccessLadder'),
      meta: {
        auth: true,
        layout: 'empty',
      },
    },
    {
      path: 'success-wall/chairmans-club',
      name: 'ChairmansClub',
      component: load('SuccessWall/ChairmansClub'),
      meta: {
        auth: true,
        layout: 'empty',
      },
    },
    {
      path: 'success-wall/chairmans-club/:id',
      name: 'ChairmansDetail',
      component: load('SuccessWall/ChairmansDetail'),
      meta: {
        auth: true,
        layout: 'empty',
      },
    },
    {
      path: 'success-wall/category/:id',
      name: 'SuccessCategory',
      component: load('SuccessWall/SuccessCategory'),
      meta: {
        auth: true,
        layout: 'empty',
      },
    },
    {
      path: 'success-wall/person/:categoryID/:date/',
      name: 'SuccessDateGroup',
      component: load('SuccessWall/SuccessDateGroup'),
      meta: {
        auth: true,
        layout: 'empty',
      },
    },
    {
      path: 'success-wall/person/:categoryID/:date/:id',
      name: 'SuccessPerson',
      component: load('SuccessWall/SuccessPerson'),
      meta: {
        auth: true,
        layout: 'empty',
      },
    },
    // {
    //   path: 'leaderboard',
    //   name: 'Leaderboard',
    //   component: load('Leaderboard'),
    //   meta: {
    //     auth: true,
    //     layout: 'default',
    //   },
    // },
    {
      path: 'register/:referral',
      name: 'Referral',
      redirect: () => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { name: 'Home' }
      },
      component: load('Home'),
      meta: {
        auth: false,
        layout: 'default',
      },
    },
    // {
    //   path: 'mandarin-prediction',
    //   name: 'MandarinPrediction',
    //   component: load('mandarin-prediction/Start'),
    //   meta: {
    //     auth: false,
    //     layout: 'empty',
    //   },
    // },
    // {
    //   path: 'mandarin-prediction/predictions',
    //   name: 'Predictions',
    //   component: load('mandarin-prediction/MandarinPrediction'),
    //   meta: {
    //     auth: false,
    //     layout: 'empty',
    //   },
    // },
    // {
    //   path: 'mandarin-prediction/:id',
    //   name: 'Prediction',
    //   component: load('mandarin-prediction/Prediction'),
    //   meta: {
    //     auth: false,
    //     layout: 'empty',
    //   },
    // },
  ]
}

const routes = [
  {
    path: '/',
    component: {
      template: '<router-view/>',
    },
    children: [...routePath].map(function (el) {
      return {
        ...el,
        beforeEnter: Trans.routeMiddleware,
        name: el.name,
      }
    }),
  },

  // Страницы с явно указанными локалями
  {
    path: `/:locale(${process.env.VUE_APP_I18N_SUPPORTED_LOCALE.replace(
      /,/g,
      '|'
    )})/`,
    component: {
      template: '<router-view/>',
    },
    children: [
      ...routePath
        .map(function (el) {
          // if (el.name === 'Webinars') {
          //   return {
          //     ...el,
          //     redirect: () => {
          //       return { name: 'HomeLoc' }
          //     },
          //     beforeEnter: Trans.routeMiddleware,
          //     name: el.name + 'Loc',
          //   }
          // }
          return {
            ...el,
            beforeEnter: Trans.routeMiddleware,
            name: el.name + 'Loc',
          }
        })
        .concat({
          path: `*`,
          name: '404Loc',
          beforeEnter: Trans.routeMiddleware,
          component: load('404'),
          meta: {
            layout: 'default',
          },
        }),
    ],
  },
  {
    path: '/authorize',
    name: 'HomeTgAuth',
    meta: {
      layout: 'default',
    },
    component: load('Home'),
  },
  {
    path: `/*`,
    name: '404',
    beforeEnter: Trans.routeMiddleware,
    component: load('404'),
    meta: {
      layout: 'default',
    },
  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (to.hash.replace('#', '')) {
        return {
          selector: to.hash,
        }
      } else {
        if (to.path !== from.path) {
          return { x: 0, y: 0 }
        }
      }
    }
  },
  routes,
})

export default router
